import { useRouter } from 'next/router';
import create from 'zustand';
import shallow from 'zustand/shallow';
import tradingStore from 'lib/stores/trading';
import orderTableStore from 'features/trade/components/OrderTable/store';
import tradingModalStore from 'global/TradingModal/store';
import useSecuritiesCredentialStore from 'global/Securities/stores/useSecuritiesCredentialStore';
import useUIConfigStore from 'stores/useUIConfigStore';
import mainLayoutStore from '../store';
import ModalError from './index';

const useTradingStore = create(tradingStore);
const useMainLayoutStore = create(mainLayoutStore);

export default function ModalErrorManager() {
  const router = useRouter();
  const resetTradingModal = tradingModalStore((s) => s.resetModal);
  const resetOrderTable = orderTableStore((s) => s.resetOrderTableStore);
  const {
    errorCodeSecurities,
    errorTypeSecurities,
    errorMessageSecurities,
    resetErrorCodeSecurities,
  } = useTradingStore(
    (s) => ({
      errorCodeSecurities: s.errorCode,
      errorTypeSecurities: s.errorType,
      errorMessageSecurities: s.errorMessage,
      resetErrorCodeSecurities: s.resetErrorCode,
    }),
    shallow,
  );
  const {
    errorCodeSocial,
    errorTypeSocial,
    errorMessageSocial,
    resetErrorCodeSocial,
  } = useMainLayoutStore(
    (s) => ({
      errorCodeSocial: s.errorCode,
      errorTypeSocial: s.errorType,
      errorMessageSocial: s.errorMessage,
      resetErrorCodeSocial: s.resetErrorCode,
    }),
    shallow,
  );

  const currentPath = router?.asPath;
  const securitiesPathPattern = /securities\/.+/;
  const securitiesPath = securitiesPathPattern.test(currentPath);

  const handleLogoutSecurities = async () => {
    await useSecuritiesCredentialStore.getState().loadLogout();
    resetOrderTable();
    resetTradingModal();
    useUIConfigStore.getState().setUIValue('featureFlags', {});

    if (securitiesPath) router.push('/stream');
  };

  const handleLogoutSocial = () => {
    router.push('/logout');
  };

  return (
    <>
      <ModalError
        dataCy="modal-error-trading"
        zIndex={1002}
        errorCode={errorCodeSecurities}
        errorType={errorTypeSecurities}
        errorMessage={errorMessageSecurities}
        onLogout={handleLogoutSecurities}
        onClose={resetErrorCodeSecurities}
        isErrorSecurities
      />
      <ModalError
        dataCy="modal-error-social"
        zIndex={1001}
        errorCode={errorCodeSocial}
        errorType={errorTypeSocial}
        errorMessage={errorMessageSocial}
        onLogout={handleLogoutSocial}
        onClose={resetErrorCodeSocial}
        isErrorSecurities={false}
      />
    </>
  );
}
